export default class User {
  static async retrieve(axios, id) {
    const response = await axios
      .post(
        "/graphql/",
        `query{
        userRetrieve(id: ${id}) {
          id
          affiliate
          username
          firstName
          lastName
          email
          profile {
            id
            phone
            birthday
            personalRef
            foreignRef
            country {
              id
              name
            }
            region {
              id
              name
            }    
            city {
              id
              name
            }             
            image {
              id
              url
            }
          }
          groups {
            id
            name
            permissions {
                id
                name
              }
          }
          isActive
          isStaff
          userPermissions {
            id
            name
          }
          employment {
            id
            branchOffice {
              id
              name
              company {
                name
                logo {
                  url
                }
              }              
            }
          }
          manager {
            id
            sendNotif
            company {
              id
              name
              notifAuth
              logo {
                url
              }
            }
          }               
        }
      }`,
        {
          headers: {
            "Content-Type": "application/graphql",
          },
        }
      )
      .catch(function(error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);

          // if (error.response.status === 400) {
          // store.dispatch('actionsSetErrorMessage', 'Usuario o contraseña incorrectos');
          // }
          console.log("primer strike");
          return null;
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.log(error.request);
          // store.dispatch('actionsSetErrorMessage', 'Usuario o contraseña incorrectos');
          console.log("segudo strike");

          return null;
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          // store.dispatch('actionsSetErrorMessage', 'Usuario o contraseña incorrectos');
          console.log("3er strike");

          return null;
        }
      });

    if (response) {
      if (
        response.data.data.userRetrieve &&
        response.data.data.userRetrieve?.profile !== null
      ) {
        response.data.data.userRetrieve.compressed = {
          country: response.data.data.userRetrieve.profile?.country,
          region: response.data.data.userRetrieve.profile?.region,
          city: response.data.data.userRetrieve.profile?.city,
          groups: response.data.data.userRetrieve.groups?.map((group) => group),
        };
        response.data.data.userRetrieve.profile.country =
          response.data.data.userRetrieve.profile.country.id;
        response.data.data.userRetrieve.profile.region =
          response.data.data.userRetrieve.profile.region.id;
        response.data.data.userRetrieve.profile.city =
          response.data.data.userRetrieve.profile.city.id;
        response.data.data.userRetrieve.profile.phone =
          response.data.data.userRetrieve.profile.phone !== null
            ? response.data.data.userRetrieve.profile.phone
            : "";
      }

      response.data.data.userRetrieve.groups = response.data.data.userRetrieve?.groups.map(
        (group) => group.id
      );

      return response.data.data.userRetrieve;
    }
  }

  static async all(axios, active, affiliate) {
    const response = await axios?.post(
      "/graphql/",
      `query {
          userList(active:${active}, affiliate:${affiliate}) {
              id
              affiliate
              dateJoined
              username
              firstName
              lastName
              email
              profile {
                phone
                birthday
                personalRef
                foreignRef
                image {
                  id
                  url
                }
              }
              groups{
                id
                name
                permissions{
                  id
                  name
                }
              }
              isActive
              isStaff
              userPermissions{
                id
                name
              }
          }
        }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );
    return response.data.data?.userList;
  }

  static async filter(axios) {
    const response = await axios.post(
      "/graphql/",
      `query{
        userList{
            id
            affiliate
            username
            firstName
            lastName
            email
            profile {
              phone
              birthday
              personalRef
              foreignRef
              image {
                id
                url
              }
            }
            groups{
              id
              name
              permissions{
                id
                name
              }
            }
            isActive
            isStaff
            userPermissions{
              id
              name
            }

        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );
    return response.data.data.userList.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      "/graphql/",
      {
        query: `mutation deleteUser ($id: ID!){
          deleteUser(id: $id){
            ok
          }
        }`,
        variables: {
          id: id,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data.data.deleteUser.ok;
  }

  static async create(
    axios,
    username,
    email,
    firstName,
    lastName,
    isStaff,
    isActive,
    groups,
    affiliate
    // phone,
    // birthday,
    // image,
    // country,
    // region,
    // city
  ) {
    // const imageField = (image > 0) ? `image: ${image},` : ``;
    // const birthdayField = (birthday !== '' && birthday !== null) ? `birthday: "${birthday}",` : ``;

    const response = await axios.post(
      "/graphql/",
      `mutation{
        createUser (
          newCustomuser: {
            username: "${username}",
            email: "${email}",
            firstName: "${firstName}",
            lastName: "${lastName}",
            isStaff: ${isStaff},
            isActive: ${isActive},
            groups: ${groups},
            affiliate: ${affiliate}
          }
        ) {
          ok
        }
      }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );

    return response.data.data.createUser.ok;
  }

  static async edit(
    axios,
    id,
    username,
    email,
    firstName,
    lastName,
    isStaff,
    isActive,
    groups,
    phone,
    birthday,
    image,
    country,
    region,
    city,
    affiliate
  ) {
    const imageField = image > 0 ? `image: ${image},` : ``;
    const birthdayField =
      birthday !== "" && birthday !== null ? `birthday: "${birthday}",` : ``;

    const update_user = await axios.post(
      "/graphql/",
      `mutation{
          updateUser(newCustomuser:{
            id:${id}
            username: "${username}",
            email: "${email}",
            firstName: "${firstName}",
            lastName: "${lastName}",
            isStaff: ${isStaff},
            isActive: ${isActive},
            groups: ${groups},
            affiliate: ${affiliate}
          }){
            customuser{
              id
              email
              firstName
              lastName
            }
            ok
            errors{
              messages
            }
          }
        }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );
    const update_profile = await axios.post(
      "/graphql/",
      `mutation{
          updateProfile(newProfile:{
            id:${id}
            image:${imageField}
            phone: "${phone}",
            birthday:${birthdayField}
            country: ${country},
            region: ${region},
            city: ${city}
          }){
            profile {
                birthday
                created
                foreignRef
                id
                modified
                personalRef
                phone
                tokenDevice
                fullName
            }
            ok
            errors{
              messages
            }
          }
        }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );
    if (
      update_profile.data.data.updateProfile.ok &&
      update_user.data.data.updateUser.ok
    ) {
      return update_user.data.data.updateUser.ok;
    } else {
      return false;
    }
  }

  static async userAvailableEmployment(axios, affiliate) {
    const response = await axios
      .post(
        "/graphql/",
        `query {
        userListAvailable(affiliate:${affiliate}) {
          id
          username
          firstName
          lastName
          email
        }
      }`,
        {
          headers: {
            "Content-Type": "application/graphql",
          },
        }
      )
      .catch(function(error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);

          // if (error.response.status === 400) {
          // store.dispatch('actionsSetErrorMessage', 'Usuario o contraseña incorrectos');
          // }
          console.log("primer strike");
          return null;
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.log(error.request);
          // store.dispatch('actionsSetErrorMessage', 'Usuario o contraseña incorrectos');
          console.log("segudo strike");

          return null;
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          // store.dispatch('actionsSetErrorMessage', 'Usuario o contraseña incorrectos');
          console.log("3er strike");
          return null;
        }
      });
    if (response !== null && response.data !== undefined) {
      if (response.data.data.userListAvailable) {
        return response.data.data.userListAvailable;

        // return response.data.data.tokenAuth;
      } else {
        // store.dispatch('actionsSetErrorMessage', 'error...!!!');
        console.log("el mensaje de error..!!", "ERROR...");
        return null;
      }
    } else {
      return null;
    }
  }

  static async edit_noactive(axios, id, active) {
    const update_user = await axios.post(
      "/graphql/",
      `mutation{
          updateUser(newCustomuser:{
            id:${id}
            isActive: ${active},
          }){
            customuser{
              id
              email
              firstName
              lastName
            }
            ok
            errors{
              messages
            }
          }
        }`,
      {
        headers: {
          "Content-Type": "application/graphql",
        },
      }
    );
    if (update_user.data.data.updateUser.ok) {
      return update_user.data.data.updateUser.ok;
    } else {
      return false;
    }
  }
}
